import * as constants from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const PRReturnPolozky = {
	name: constants.NAME,
	constants,
	apiProvider,
	router,
};
